
import { z } from "zod";

export const SowChangeTypeValues = ["elective", "existingQuote", "insuranceFinancialAdjustment", "lineItems", "newQuote", "panelCount", "supplement", "supplementAndElective"] as const;
export const SowChangeTypeSchema = z.enum(SowChangeTypeValues);
export const SowChangeType = SowChangeTypeSchema.enum;
export type SowChangeType = (typeof SowChangeTypeValues)[number];
export const SowChangeTypeDisplayNames = { "elective": "Elective",
"existingQuote": "Existing quote",
"insuranceFinancialAdjustment": "Insurance Financial Adjustment",
"lineItems": "Add Line Item",
"newQuote": "New quote",
"panelCount": "Solar panel count",
"supplement": "Supplement",
"supplementAndElective": "Supplement + Elective", } satisfies Record<SowChangeType, string>;
